import { NavLink } from 'react-router-dom';
import { RouteIcons } from '../../assets/icons';
import { BasePath } from '../../config/constants';

const bottomNavLinks = [
    {
        label: 'Referrals',
        to: BasePath.REFERRALS,
        routeIcon: RouteIcons[BasePath.REFERRALS],
    },
    {
        label: 'Pools',
        to: BasePath.POOLS,
        routeIcon: RouteIcons[BasePath.POOLS],
    },
    {
        label: 'Trade',
        to: `${BasePath.TRADE}/BTCUSD`,
        routeIcon: RouteIcons[BasePath.TRADE],
    },
    {
        label: 'Analytics',
        to: BasePath.ANALYTICS,
        routeIcon: RouteIcons[BasePath.ANALYTICS],
    },
    {
        label: 'Leaderboard',
        to: BasePath.LEADERBOARD,
        routeIcon: RouteIcons[BasePath.LEADERBOARD],
    },
];

const BottomNav = () => (
    <nav className='bottom-nav'>
        <div className='container'>
            {bottomNavLinks.map(({ label, to, routeIcon }, index) => (
                <NavLink key={index} to={to}>
                    <div className='icon-container'>{routeIcon}</div>
                    <span>{label}</span>
                </NavLink>
            ))}
        </div>
    </nav>
);

export default BottomNav;
